export default __webpack_public_path__ + "static/media/networks.621a7e4b.svg";